import { render, staticRenderFns } from "./SubOrderGraph.vue?vue&type=template&id=147dbf6b&scoped=true&"
import script from "./SubOrderGraph.vue?vue&type=script&lang=js&"
export * from "./SubOrderGraph.vue?vue&type=script&lang=js&"
import style0 from "./SubOrderGraph.vue?vue&type=style&index=0&id=147dbf6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147dbf6b",
  null
  
)

/* custom blocks */
import block0 from "./SubOrderGraph.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports